<footer class="app-footer">
  <div class="footer-main">
    <div class="footer-left">
      <img
        src="assets/images/logo/pitch59-logo-white.svg"
        alt="pitch59 logo"
        class="footer-logo"
      />
      <ul class="social-icons">
        <li *ngFor="let socialLink of socialLinksArray">
          <a [href]="socialLink.url" target="_blank">
            <img
              [alt]="socialLink.alt"
              [ngSrc]="socialLink.imageSrc"
              width="36"
              height="36"
            />
          </a>
        </li>
      </ul>
      <div class="copyright-text">
        ©{{ currentYear }} pitch59. All Rights Reserved.
      </div>
    </div>
    <div class="footer-divider"></div>
    <div class="footer-right">
      <ng-container *ngFor="let link of rightLinks">
        <a *ngIf="link.external" [href]="link.url" target="_blank">{{
            link.label
          }}</a>
        <a
          *ngIf="!link.external && link.action === 'contact'"
          (click)="handleLinkClick(link)"
          style="cursor: pointer"
        >{{ link.label }}</a
        >
        <a
          *ngIf="!link.external && link.action !== 'contact'"
          [routerLink]="link.url"
        >{{ link.label }}</a
        >
      </ng-container>
    </div>
  </div>
</footer>
